
function inIframe() {
    return (window !== window.parent && window.top.location.pathname.indexOf('/admin') >= 0 && window.top.location.pathname.indexOf('/editor') >= 0) ? true : false;
}
if (inIframe()) {
    // get homepages settings

    let homepages = $('#import_modal-section').attr('data-settings'),
        layouts_settings;
    $.get(homepages, function(data, status) {
        if (status == 'success') {
            layouts_settings = data;
        }
    });
    $('.open_import_btn').addClass('visible');
    function type(value) {
        let regex = /^\[object (\S+?)\]$/;
        let matches = Object.prototype.toString.call(value).match(regex) || [];
        return (matches[1] || 'undefined').toLowerCase();
    }
    function jsonToMap(obj,map_obj,part) {
        return map_obj = map_obj || [], $.each(obj, function( key, item) {
            let i = part ? part + "[" + key + "]" : key;
            if(!(obj[item] === Object(obj[item]))){
                if(type(item) == 'array' || item === Object(item) ){
                    $.each(item, function( key_section, item_section) {
                        let part_two = i + "[" + key_section + "]";
                        if(type(item) == 'array'){
                            part_two = i + "[]";
                        }
                        if(item_section === Object(item_section)){
                            jsonToMap(item_section, map_obj, part_two);
                        }
                        else{
                            map_obj.push({
                                name: part_two,
                                value: item_section
                            });
                        }
                    });
                }
                else{
                    map_obj.push({
                        name: i,
                        value: item
                    });
                }
            }
            else{
                jsonToMap(obj[item], map_obj, i)
            }
        }), map_obj;
    }
    function html( id, img, title ) {
        return `<div class="theme_import_item"><div class="import_item"><img src="${img}" alt=""><div class="import_item_desc"><span>${title}</span><button class="theme_import_btn" data-layout="${id}"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="20" height="18" viewBox="0 0 20 18"><path d="M16.945,18.000 L3.055,18.000 C1.370,18.000 0.000,16.597 0.000,14.872 L0.000,12.879 C0.000,12.592 0.228,12.358 0.509,12.358 C0.790,12.358 1.018,12.592 1.018,12.879 L1.018,14.872 C1.018,16.022 1.932,16.957 3.055,16.957 L16.945,16.957 C18.068,16.957 18.982,16.022 18.982,14.872 L18.982,12.879 C18.982,12.592 19.210,12.358 19.491,12.358 C19.772,12.358 20.000,12.592 20.000,12.879 L20.000,14.872 C20.000,16.597 18.630,18.000 16.945,18.000 ZM16.400,15.455 L3.600,15.455 C3.319,15.455 3.091,15.222 3.091,14.934 C3.091,14.646 3.319,14.412 3.600,14.412 L16.400,14.412 C16.681,14.412 16.909,14.646 16.909,14.934 C16.909,15.222 16.681,15.455 16.400,15.455 ZM10.848,11.715 C10.606,11.936 10.303,12.046 10.000,12.046 C9.697,12.046 9.394,11.936 9.152,11.715 L4.887,7.813 C4.678,7.621 4.660,7.292 4.847,7.077 C5.034,6.862 5.356,6.844 5.566,7.036 L9.491,10.626 L9.491,0.521 C9.491,0.233 9.719,0.000 10.000,0.000 C10.281,0.000 10.509,0.233 10.509,0.521 L10.509,10.626 L14.434,7.036 C14.644,6.844 14.966,6.862 15.153,7.077 C15.340,7.292 15.322,7.621 15.113,7.813 L10.848,11.715 Z" class="an_cls-1"/></svg><img src="https://promo.anvanto.com/blackery/import_page/loading.gif" alt="gif"></button></div></div></div>`;
    }
    function codeGenerator(){
        let layouts = {
            home1: {
                id: 'home1',
                img_url: 'https://promo.anvanto.com/blackery/import_page/home_01.jpg',
                title: 'Home page 01'
            },
            home2: {
                id: 'home2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/home_02.jpg',
                title: 'Home page 02'
            },
            home3: {
                id: 'home3',
                img_url: 'https://promo.anvanto.com/blackery/import_page/home_03.jpg',
                title: 'Home page 03'
            },
            home4: {
                id: 'home4',
                img_url: 'https://promo.anvanto.com/blackery/import_page/home_04.jpg',
                title: 'Home page 04'
            },
            home5: {
                id: 'home5',
                img_url: 'https://promo.anvanto.com/blackery/import_page/home_05.jpg',
                title: 'Home page 05'
            },
            home6: {
                id: 'home6',
                img_url: 'https://promo.anvanto.com/blackery/import_page/home_06.jpg',
                title: 'Home page 06'
            },
            home7: {
                id: 'home7',
                img_url: 'https://promo.anvanto.com/blackery/import_page/home_07.jpg',
                title: 'Home page 07'
            },
            home8: {
                id: 'home8',
                img_url: 'https://promo.anvanto.com/blackery/import_page/home_08.jpg',
                title: 'Home page 08'
            },
            home9: {
                id: 'home9',
                img_url: 'https://promo.anvanto.com/blackery/import_page/home_09.jpg',
                title: 'Home page 09'
            },
            cosmetics: {
                id: 'cosmetics',
                img_url: 'https://promo.anvanto.com/blackery/import_page/home_10.jpg',
                title: 'Home cosmetics v.1'
            },
            digit: {
                id: 'digit',
                img_url: 'https://promo.anvanto.com/blackery/import_page/digit.jpg',
                title: 'Home digit v.1'
            },
            home11: {
                id: 'home11',
                img_url: 'https://promo.anvanto.com/blackery/import_page/home_11.jpg',
                title: 'Home page 11'
            },
            home12: {
                id: 'home12',
                img_url: 'https://promo.anvanto.com/blackery/import_page/home_12.jpg',
                title: 'Home page 12'
            },
            decor: {
                id: 'decor',
                img_url: 'https://promo.anvanto.com/blackery/import_page/home_14.jpg',
                title: 'Home decor v.1'
            },
            lingerie: {
                id: 'lingerie',
                img_url: 'https://promo.anvanto.com/blackery/import_page/home_15.jpg',
                title: 'Home lingerie v.1'
            },
            cosmetics2: {
                id: 'cosmetics2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/cosmetics2.jpg',
                title: 'Home cosmetics v.2'
            },
            cosmetics3: {
                id: 'cosmetics3',
                img_url: 'https://promo.anvanto.com/blackery/import_page/cosmetics3.jpg',
                title: 'Home cosmetics v.3'
            },
            digit2: {
                id: 'digit2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/digit2.jpg',
                title: 'Home digit v.2'
            },
            digit3: {
                id: 'digit3',
                img_url: 'https://promo.anvanto.com/blackery/import_page/digit3.jpg',
                title: 'Home digit v.3'
            },
            digit4: {
                id: 'digit4',
                img_url: 'https://promo.anvanto.com/blackery/import_page/digit4.jpg',
                title: 'Home digit v.4'
            },
            digit5: {
                id: 'digit5',
                img_url: 'https://promo.anvanto.com/blackery/import_page/digit5.jpg',
                title: 'Home digit v.5'
            },
            decor2: {
                id: 'decor2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/decor2.jpg',
                title: 'Home decor v.2'
            },
            lingerie2: {
                id: 'lingerie2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/lingerie2.jpg',
                title: 'Home lingerie v.2'
            },
            cars: {
                id: 'cars',
                img_url: 'https://promo.anvanto.com/blackery/import_page/cars.jpg',
                title: 'Home cars v.1'
            },
            cars2: {
                id: 'cars2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/cars2.jpg',
                title: 'Home cars v.2'
            },
            pets: {
                id: 'pets',
                img_url: 'https://promo.anvanto.com/blackery/import_page/pets.jpg',
                title: 'Home pets v.1'
            },
            pets2: {
                id: 'pets2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/pets2.jpg',
                title: 'Home pets v.2'
            },
            pets3: {
                id: 'pets3',
                img_url: 'https://promo.anvanto.com/blackery/import_page/pets3.jpg',
                title: 'Home pets v.3'
            },
            kids: {
                id: 'kids',
                img_url: 'https://promo.anvanto.com/blackery/import_page/kids.jpg',
                title: 'Home kids v.2'
            },
            kids2: {
                id: 'kids2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/kids2.jpg',
                title: 'Home kids v.2'
            },
            kids3: {
                id: 'kids3',
                img_url: 'https://promo.anvanto.com/blackery/import_page/kids3.jpg',
                title: 'Home kids v.3'
            },
            plants: {
                id: 'plants',
                img_url: 'https://promo.anvanto.com/blackery/import_page/plants.jpg',
                title: 'Home plants v.1'
            },
            plants2: {
                id: 'plants2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/plants2.jpg',
                title: 'Home plants v.2'
            },
            wine: {
                id: 'wine',
                img_url: 'https://promo.anvanto.com/blackery/import_page/wine.jpg',
                title: 'Home wine v.1'
            },
            vape: {
                id: 'vape',
                img_url: 'https://promo.anvanto.com/blackery/import_page/vape.jpg',
                title: 'Home vape v.1'
            },
            vape2: {
                id: 'vape2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/vape2.jpg',
                title: 'Home vape v.2'
            },
            meat: {
                id: 'meat',
                img_url: 'https://promo.anvanto.com/blackery/import_page/meat.jpg',
                title: 'Home meat v.1'
            },
            meat2: {
                id: 'meat2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/meat2.jpg',
                title: 'Home meat v.2'
            },
            meat3: {
                id: 'meat3',
                img_url: 'https://promo.anvanto.com/blackery/import_page/meat3.jpg',
                title: 'Home meat v.3'
            },
            mens_fashion: {
                id: 'mens_fashion',
                img_url: 'https://promo.anvanto.com/blackery/import_page/mens_fashion.jpg',
                title: 'Home mens fashion v.1'
            },
            mens_fashion2: {
                id: 'mens_fashion2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/mens_fashion2.jpg',
                title: 'Home mens fashion2 v.2'
            },
            shoes: {
                id: 'shoes',
                img_url: 'https://promo.anvanto.com/blackery/import_page/shoes.jpg',
                title: 'Home shoes v.1'
            },
            shoes2: {
                id: 'shoes2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/shoes2.jpg',
                title: 'Home shoes v.2'
            },
            shoes3: {
                id: 'shoes3',
                img_url: 'https://promo.anvanto.com/blackery/import_page/shoes3.jpg',
                title: 'Home shoes v.2'
            },
            musical_instruments: {
                id: 'musical_instruments',
                img_url: 'https://promo.anvanto.com/blackery/import_page/musical_instruments.jpg',
                title: 'Home musical instruments v.1'
            },
            jewelry: {
                id: 'jewelry',
                img_url: 'https://promo.anvanto.com/blackery/import_page/jewelry.jpg',
                title: 'Home jewelry v.1'
            },
            jewelry3: {
                id: 'jewelry3',
                img_url: 'https://promo.anvanto.com/blackery/import_page/jewelry3.jpg',
                title: 'Home jewelry v.3'
            },
            sports_nutrition: {
                id: 'sports_nutrition',
                img_url: 'https://promo.anvanto.com/blackery/import_page/sports_nutrition.jpg',
                title: 'Home sports nutrition v.1'
            },
            sports_nutrition2: {
                id: 'sports_nutrition2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/sports_nutrition2.jpg',
                title: 'Home sports nutrition v.2'
            },
            motorcycle_gear: {
                id: 'motorcycle_gear',
                img_url: 'https://promo.anvanto.com/blackery/import_page/motorcycle_gear.jpg',
                title: 'Home motorcycle gear v.1'
            },
            food: {
                id: 'food',
                img_url: 'https://promo.anvanto.com/blackery/import_page/food.jpg',
                title: 'Home food v.1'
            },
            food2: {
                id: 'food2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/food2.jpg',
                title: 'Home food v.2'
            },
            food3: {
                id: 'food3',
                img_url: 'https://promo.anvanto.com/blackery/import_page/food3.jpg',
                title: 'Home food v.3'
            },
            knives: {
                id: 'knives',
                img_url: 'https://promo.anvanto.com/blackery/import_page/knives.jpg',
                title: 'Home knives v.1'
            },
            knives2: {
                id: 'knives2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/knives2.jpg',
                title: 'Home knives v.2'
            },
            cakes: {
                id: 'cakes',
                img_url: 'https://promo.anvanto.com/blackery/import_page/cakes.jpg',
                title: 'Home cakes v.1'
            },
            cakes2: {
                id: 'cakes2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/cakes2.jpg',
                title: 'Home cakes v.2'
            },
            travel: {
                id: 'travel',
                img_url: 'https://promo.anvanto.com/blackery/import_page/travel.jpg',
                title: 'Home travel v.1'
            },
            doors: {
                id: 'doors',
                img_url: 'https://promo.anvanto.com/blackery/import_page/doors.jpg',
                title: 'Home doors v.1'
            },
            sushi: {
                id: 'sushi',
                img_url: 'https://promo.anvanto.com/blackery/import_page/sushi.jpg',
                title: 'Home sushi v.1'
            },
            sushi2: {
                id: 'sushi2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/sushi2.jpg',
                title: 'Home sushi v.2'
            },
            pizza: {
                id: 'pizza',
                img_url: 'https://promo.anvanto.com/blackery/import_page/pizza.jpg',
                title: 'Home pizza v.1'
            },
            bikes: {
                id: 'bikes',
                img_url: 'https://promo.anvanto.com/blackery/import_page/bikes.jpg',
                title: 'Home bikes v.1'
            },
            bikes2: {
                id: 'bikes2',
                img_url: 'https://promo.anvanto.com/blackery/import_page/bikes2.jpg',
                title: 'Home bikes v.2'
            },
            bikes3: {
                id: 'bikes3',
                img_url: 'https://promo.anvanto.com/blackery/import_page/bikes3.jpg',
                title: 'Home bikes v.3'
            }
        };

        $.each(layouts, function( key, value) {
            let id = value.id,
                image_url = value.img_url,
                title = value.title;
            $('.theme_import_items').append(html(id,image_url,title));
        });
        $('.theme_import_items').append('<div class="theme_import_item"></div>');
        $('.theme_import_items').append('<div class="theme_import_item"></div>');
    }
    function deleteProperties(object,keys) {
        $.each(keys, function( index, value ) {
            delete object[value];
        })
    }
    function isEmpty(obj) {
        for (var key in obj) {
            return false;
        }
        return true;
    }
    function settingsFormatted(object) {
        let object_formatted = {};
        let setting_value;
        $.each(object, function( key, item) {
            if(item != undefined){
                setting_value = item.value;
                if(item.value === Object(item.value)){
                    item.value.url === undefined && item.value.handle === undefined ? setting_value = '' : setting_value = item.value.url || item.value.handle ;
                }
                if(item.type == 'image_picker'){
                    setting_value = $(top.document).find(`.te-sidebar [name="${item.input_name}"]`).attr('value');
                }
                object_formatted[item.id] = setting_value;
            }
        });
        return object_formatted;
    }
    function userSettings() {
        let default_settings = top.window.Shopify.themeSettings;
        let default_section = top.window.Shopify.sections;
        let full_settingsFormatted = settingsFormatted(default_settings);

        //section.settings formatting
        $.each(default_section, function( key, item) {
            if(item.type_setting != undefined) {
                item.type = item.type_setting.value;
            }
            if(item.block_order_setting != undefined){
                item.block_order = item.block_order_setting.value;
            }
            item.settings = settingsFormatted(item.settings);
            deleteProperties(item,['block_order_setting','accepts_blocks','disabled_setting','icon','name','type_setting']);

            $.each(item.blocks, function( key_block, item_block) {
                item_block.settings = settingsFormatted(item_block.settings);
                deleteProperties(item_block,['icon','name','type_setting']);
            });
            if(isEmpty(item.blocks)){
                deleteProperties(item,['blocks']);
            }
        });
        full_settingsFormatted.sections = default_section;
        full_settingsFormatted.content_for_index = top.window.Shopify.contentForIndex;
        $('#export_area').val(JSON.stringify(full_settingsFormatted));
    }
    function importData(data) {
        let params = {
            method: "PATCH",
            url: top.Shopify.routes.theme_editor_save(top.THEME_ID).html,
            data: data,
            success: function() {
                top.window.location.reload();
            },
            error: function (AjaxRequest, textStatus) {
                console.info(AjaxRequest);
                alert("Import Errors");
            }
        };
        top.Shopify.ajax(params);
    }
    codeGenerator();
    $('.open_import_btn').magnificPopup({
        removalDelay: 500,
        type: 'inline',
        mainClass: 'import_magnific_popup',
        callbacks: {
            beforeOpen: function() {
                userSettings();
            }
        },
        midClick: true
    });
    //copy to clipboard
    $(document).on('click', '#export_area_btn', function(event) {
        event.preventDefault();
        $("#export_area").select();
        let copy = document.execCommand('copy');
        if(copy){
            $('.import_export_item.export').addClass("copied");
            window.getSelection().removeAllRanges();
            $(this).text('Copied');
        }
    });
    $(document).on('click', '#import_area_btn', function() {
        let import_settings = $('#import_area').val();
        try {
            importData(jsonToMap(JSON.parse(import_settings), false, 'settings'));
        } catch (e) {
            alert("Import Errors");
        }
    });
    $(document).on('click', '.theme_import_btn', function() {
        $(this).addClass('loading active');
        let item_settings = layouts_settings.presets[`${$(this).attr('data-layout')}`];
        try {
            importData(jsonToMap(item_settings, false, 'settings'));
        } catch (e) {
            $(this).removeClass('loading active');
        }
    });
}